import { useContext } from 'react';
import { AuthContext, AuthContextValue, AuthUser } from './AuthProvider';

/**
 * Custom hook for accessing authentication state and actions.
 * Provides a clean interface for authentication throughout the app.
 */
export function useAuth(): AuthContextValue & {
  userName: string | null;
  roles: string[];
  hasRole: (role: string) => boolean;
} {
  const auth = useContext(AuthContext);

  // Extract user display name
  const getUserName = (): string | null => {
    if (!auth.user) return null;
    return auth.user.name || auth.user.email || 'User';
  };

  // Extract roles
  const getRoles = (): string[] => {
    return auth.user?.roles ?? [];
  };

  // Check if user has a specific role
  const hasRole = (role: string): boolean => {
    return getRoles().includes(role);
  };

  return {
    ...auth,
    userName: getUserName(),
    roles: getRoles(),
    hasRole,
  };
}

export type { AuthUser };
